export default "__VITE_ASSET__CnVx45hV__"